import { httpMethod, useApi } from './useApi';
/**
 * Hook to exchange the authorization code in exchange of an authentication access token
 * @deprecated
 */
export const usePostToken = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: false,
        path: 'auth/exchange-token',
        httpMethod: httpMethod.POST,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useGetIdentities = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'auth/identities',
        httpMethod: httpMethod.GET,
    });
    const responseData = data;
    return { call, data: responseData, error, ...rest };
};
export const usePostIdentities = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'auth/identities',
        httpMethod: httpMethod.POST,
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useDeleteIdentities = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'auth/identities',
        httpMethod: httpMethod.DELETE,
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
